import React, { FunctionComponent, SVGProps } from 'react';

const SvgComponent: FunctionComponent<SVGProps<SVGSVGElement>> = props => (
  <svg width={1155} height={700} viewBox="0 0 1155 700" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M570.157 283.292c-2.9.356-5.897.536-8.985.536-27.766 0-48.181-14.498-57.488-39.916v13.647h-17.286v22.363h-57.062v-22.363H360v-33.301c12.5-24.512 26.758-47.949 51.172-85.254h75.226v86.816h12.829c-.754-5.261-1.141-10.833-1.141-16.699 0-46.875 24.707-74.121 63.086-74.121 3.093 0 6.098.176 9.006.525a75.416 75.416 0 018.994-.525c38.379 0 62.988 27.148 62.988 74.023 0 2.709-.082 5.356-.246 7.94 11.647-22.015 25.397-44.364 47.383-77.959h75.226v86.816h17.286v31.739h-17.286v22.363h-57.062v-22.363h-69.336v-18.443c-8.415 28.317-29.529 44.712-58.953 44.712-3.098 0-6.105-.18-9.015-.536zm.007-113.751c-7.431 5.132-11.891 17.764-11.891 39.58 0 21.744 4.46 34.729 11.891 40.051 7.403-5.322 11.809-18.307 11.809-40.051 0-21.816-4.406-34.448-11.809-39.58zm-139.656 23.412c-6.415 10.416-12.341 20.957-18.621 33.356v1.171h18.621v-34.527zm259.504 34.527h18.621v-34.527c-6.415 10.416-12.341 20.957-18.621 33.356v1.171z"
      fill="#fff"
    />
    <path
      d="M429.336 279.922h39.062v-22.363h17.286V225.82h-17.286v-86.816h-57.226C386.758 176.309 372.5 199.746 360 224.258v33.301h69.336v22.363zm-35.449-53.613c11.425-22.559 21.679-38.965 35.84-59.668h.781v60.839h-36.621v-1.171zM561.172 283.828c38.672 0 62.988-28.32 62.988-74.805 0-46.875-24.609-74.023-62.988-74.023s-63.086 27.246-63.086 74.121c0 46.582 24.414 74.707 63.086 74.707zm0-31.836c-12.695 0-20.899-13.379-20.899-42.871 0-29.59 8.204-42.285 20.899-42.285s20.801 12.695 20.801 42.285c0 29.492-8.106 42.871-20.801 42.871zM707.461 279.922h39.062v-22.363h17.286V225.82h-17.286v-86.816h-57.226c-24.414 37.305-38.672 60.742-51.172 85.254v33.301h69.336v22.363zm-35.449-53.613c11.426-22.559 21.679-38.965 35.84-59.668h.781v60.839h-36.621v-1.171z"
      fill="#000"
      fillOpacity={0.25}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M708.372 580.949l49.266-3.449c44.5-10.5 42.5-29 20.952-47.5l-104-85s-20.813 3.13-35 4.5c-19.825 1.915-55 0-55 0l1.246 1h-54.698l-112.048 98c-11.452 14 0 33 0 33h288.5c.258-.175.519-.359.782-.551z"
      fill="#2F70EE"
    />
    <path
      d="M437.31 546.609l92.248-80.194a18.004 18.004 0 0111.81-4.415h35.064a18 18 0 0111.777 4.387l92.734 80.224a15.026 15.026 0 015.195 11.364c0 8.298-6.727 15.025-15.026 15.025H447.178c-8.306 0-15.04-6.734-15.04-15.04 0-4.354 1.887-8.495 5.172-11.351z"
      fill="#000"
      fillOpacity={0.07}
    />
    <path
      d="M761.638 577l-55 5c19.5-12.5 5.5-28.5-3.048-37l-119-95.5s35.175 1.915 55 0c14.187-1.37 35-4.5 35-4.5l104 85c25.548 22.5 17.048 35.5-16.952 47z"
      fill="#000"
      fillOpacity={0.06}
    />
    <path
      d="M615.638 472.5l82-9m-55.5 29.5l81-8.5m-59.5 27l81-8.5m-44.5 38l78.5-9.5m-62 34l76-11.5"
      stroke="#000"
      strokeOpacity={0.17}
      strokeLinecap="round"
    />
    <path
      d="M704 544l-107.5-86 86-8.5L704 544zM531.5 458L416 559c-2.4-1.6 1-7.333 3-10l103.5-91h9z"
      fill="#000"
      fillOpacity={0.06}
    />
    <path
      d="M560.638 345.5l-43.5-48 8-10.5h125.5l5.5 10.5-44 48h-51.5z"
      fill="#3072F3"
    />
    <path
      d="M608.5 287L572 345h10.5l45-47-6.5-11h-12.5z"
      fill="#000"
      fillOpacity={0.02}
    />
    <path
      d="M612.638 345h-30.5l45-47.5-6.5-10.5h30l5.5 10.5-43.5 47.5z"
      fill="#000"
      fillOpacity={0.23}
    />
    <path
      d="M627.638 297.5l-6.5-10.5h29.5l5.5 10.5h-28.5z"
      fill="#000"
      fillOpacity={0.06}
    />
    <circle cx={584.138} cy={309.5} r={4} fill="#fff" />
    <path
      d="M561 322c2.5 3.5 11 5.5 17.5 0"
      stroke="#fff"
      strokeWidth={2}
      strokeLinecap="round"
    />
    <circle cx={554.138} cy={309.5} r={4} fill="#fff" />
    <rect x={541.138} y={342.5} width={81} height={12} rx={6} fill="#1E2D67" />
    <path
      d="M443.5 299.001c0 30.5 36.833 67.666 57.5 82 0 0 3 4.499 0 7.5-3 3-8.5 0-8.5 0-45.5-39.501-54-65.501-58.5-86 2.8-4.8 6.166-4.167 9.5-3.5z"
      fill="#0988FC"
    />
    <path
      d="M487.362 372.834c-32.5-24-47-57.5-47-76h3c-.166 12.667 8.7 45 45.5 73l-1.5 3z"
      fill="#000"
      fillOpacity={0.11}
    />
    <path
      d="M491.833 374.334c-.333 2-2.4 6.1-8 6.5M481.333 364.334c-.333 2-2.4 6.1-8 6.5M469.333 352.334c-.333 2-2.4 6.1-8 6.5M458.333 337.334c-.333 2-2.4 6.1-8 6.5M449.333 323.334c-.333 2-2 5.5-7.5 4.5M444.333 310.158c-.333 2-2 5.5-7.5 4.5"
      stroke="#000"
    />
    <path
      d="M426.611 269.021a17.5 17.5 0 1022.368 10.59l-5.894 2.106a11.242 11.242 0 11-14.368-6.802l-2.106-5.894zM481.138 458.5v-108h166.5l44 4.5-4 95.5-40 8h-166.5z"
      fill="#00488A"
    />
    <path
      d="M650.138 458V351l41.5 4-4 95-37.5 8z"
      fill="#000"
      fillOpacity={0.08}
    />
    <path
      d="M681.5 446.5l9-85.5-3 89.5L662 455l19.5-8.5z"
      fill="#000"
      fillOpacity={0.11}
    />
    <path
      d="M666 454l-10-102.5h-6V458l16-4zM637.5 457.5L648 350h2v107.5h-12.5z"
      fill="#000"
      fillOpacity={0.06}
    />
    <path
      d="M481 375.5V458h90l-71.66-5.867a16 16 0 01-14.666-14.995L481 375.5z"
      fill="#000"
      fillOpacity={0.09}
    />
    <path
      d="M731.134 288.001c0 30.5-36.833 67.666-57.5 82 0 0-3 4.499 0 7.5 3 3 8.5 0 8.5 0 45.5-39.501 54-65.501 58.5-86-2.8-4.8-6.167-4.167-9.5-3.5z"
      fill="#0988FC"
    />
    <path
      d="M734.163 289.334c-2.4 39.6-42 73.167-61.5 85-1.2 0-.5-3.333 0-5 48.8-34.4 59.333-69 58.5-82l3 2z"
      fill="#000"
      fillOpacity={0.09}
    />
    <path
      d="M682.801 363.334c.333 2 2.4 6.1 8 6.5M693.301 353.334c.333 2 2.4 6.1 8 6.5M705.301 341.334c.333 2 2.4 6.1 8 6.5M716.301 326.334c.333 2 2.4 6.1 8 6.5M725.301 312.334c.333 2 2 5.5 7.5 4.5M730.301 299.158c.333 2 2 5.5 7.5 4.5"
      stroke="#000"
    />
    <path
      d="M758.559 280.539a17.501 17.501 0 01-32.85-12.078l5.875 2.16a11.24 11.24 0 1021.1 7.758l5.875 2.16z"
      fill="#00488A"
    />
    <rect x={510} y={370} width={104} height={63} rx={8} fill="#22a6b3" />
    <path
      d="M607.641 433H584.5s8.383-14.255 10.5-25.5c2.662-14.139-3-37.5-3-37.5h13.783c5.055 0 9.118 4.161 8.998 9.214l-1.142 47.929a6 6 0 01-5.998 5.857z"
      fill="#000"
      fillOpacity={0.06}
    />
    <path
      d="M510.436 425.929L510 378c3.2 42.4 19.5 54.5 26.5 54.5l-18.93.364a7 7 0 01-7.134-6.935z"
      fill="#000"
      fillOpacity={0.05}
    />
    <circle cx={547.371} cy={425.371} r={2.37097} fill="#fff" />
    <circle cx={555.5} cy={425.371} r={2.37097} fill="#EDD06C" />
    <circle cx={563.629} cy={425.371} r={2.37097} fill="#F995C5" />
    <circle cx={452} cy={549} r={4} fill="#000" fillOpacity={0.15} />
    <circle cx={469} cy={534} r={4} fill="#000" fillOpacity={0.15} />
    <circle cx={486} cy={519} r={4} fill="#000" fillOpacity={0.15} />
    <circle cx={503} cy={504} r={4} fill="#000" fillOpacity={0.15} />
    <circle cx={520} cy={489} r={4} fill="#000" fillOpacity={0.15} />
    <circle
      r={4}
      transform="matrix(-1 0 0 1 662 549)"
      fill="#000"
      fillOpacity={0.15}
    />
    <circle
      r={4}
      transform="matrix(-1 0 0 1 645 534)"
      fill="#000"
      fillOpacity={0.15}
    />
    <circle
      r={4}
      transform="matrix(-1 0 0 1 628 519)"
      fill="#000"
      fillOpacity={0.15}
    />
    <circle
      r={4}
      transform="matrix(-1 0 0 1 611 504)"
      fill="#000"
      fillOpacity={0.15}
    />
    <circle
      r={4}
      transform="matrix(-1 0 0 1 594 489)"
      fill="#000"
      fillOpacity={0.15}
    />
  </svg>
);

export default SvgComponent;
